import { Mutation, MutationTree } from "vuex";
import {
  ChannelsPageMutation,
  ChannelsPageState,
  InfoChannelData,
  ViewType
} from "@/components/channelsPage/types";
import { Categories } from "@/helpers/constants";
import { EpgItem } from "@/services/apiService/api.types";

export const mutations: MutationTree<ChannelsPageState> &
  Record<ChannelsPageMutation, Mutation<ChannelsPageState>> = {
  [ChannelsPageMutation.setCardControls](state, controlsStatus: boolean) {
    state.cardControls = controlsStatus;
  },
  [ChannelsPageMutation.setPlayedChannelId](state, channelId?: number) {
    state.playedChannelId = channelId;
  },
  [ChannelsPageMutation.setPlayedChannelIndex](state, index?: number) {
    state.playedChannelIndex = index;
  },
  [ChannelsPageMutation.setPlayedChannelCategory](
    state,
    category?: Categories
  ) {
    state.playedChannelCategory = category;
  },
  [ChannelsPageMutation.setPlayedChannelView](state, cardView?: ViewType) {
    state.playedChannelView = cardView;
  },
  [ChannelsPageMutation.setActiveChannelOverlayInfo](
    state,
    channelInfo?: InfoChannelData
  ) {
    state.activeChannelOverlayInfo = channelInfo;
  },
  [ChannelsPageMutation.setActiveInfoScreenEpgItem](state, epgItem?: EpgItem) {
    state.activeInfoScreenEpgItem = epgItem;
  },
  [ChannelsPageMutation.setShowInfoScreen](state, showInfoScreen: boolean) {
    state.showInfoScreen = showInfoScreen;
  },
  [ChannelsPageMutation.setShowEpgScreen](state) {
    state.showEpgScreen = !state.showEpgScreen;
  }
};
